<template>
  <base-modal
    :title="`${title}.${extension}`"
    :width="400"
    @closeModal="onCloseModal"
  >
    <audio-player
      :src="audioUrl"
      :volume="volume"
      @volumeChange="onVolumeChange"
    />
    <!-- <span class="info">
      During Play Mode, the asset will playback in this volume
    </span> -->
  </base-modal>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import BaseModal from './BaseModal.vue';
import AudioPlayer from '../all/AudioPlayer.vue';

export default {
  components: {
    BaseModal,
    AudioPlayer,
  },

  data() {
    return {};
  },

  computed: {
    ...mapGetters('project/data/assets', [
      'getAudioUrl',
      'getNode',
      'getExtension',
    ]),
    ...mapGetters('application/modals', ['getAudioAssetModal']),

    /**
     * Returns the ID of the asset
     */
    id() {
      const { id } = this.getAudioAssetModal;
      return id;
    },

    /**
     * Returns the Asset node
     */
    asset() {
      return this.getNode(this.id);
    },

    /**
     * Returns the audio file URL
     */
    audioUrl() {
      if (!this.getAudioAssetModal) return null;
      return this.getAudioUrl(this.id);
    },

    /**
     * Returns the title of the asset
     */
    title() {
      return this.asset.name;
    },

    /**
     * Returns the extension of the asset file
     */
    extension() {
      return this.getExtension(this.id);
    },

    volume() {
      if (Number.isNaN(this.asset.volume)) {
        return 1;
      }
      return this.asset.volume;
    },
  },

  mounted() {
    this.$el.focus();
  },

  methods: {
    ...mapActions('application/modals', ['setAudioAssetModal']),
    ...mapActions('project/data/assets', ['updateAsset']),

    onCloseModal() {
      this.setAudioAssetModal({ value: null });
    },

    onVolumeChange(event) {
      this.updateAsset({
        id: this.id,
        props: {
          volume: event.value,
        },
        apply: true,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.info {
  line-height: 3;
  width: 100%;
  text-align: center;
  display: block;
  color: #a1a1a1;
}
</style>
